var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompletedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10332_15271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5033 18.3327C5.90076 18.3327 2.16992 14.6018 2.16992 9.99935C2.16992 5.39685 5.90076 1.66602 10.5033 1.66602C15.1058 1.66602 18.8366 5.39685 18.8366 9.99935C18.8366 14.6018 15.1058 18.3327 10.5033 18.3327ZM9.67242 13.3327L15.5641 7.44018L14.3858 6.26185L9.67242 10.976L7.31492 8.61852L6.13659 9.79685L9.67242 13.3327Z",
    fill: "#121B2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10332_15271"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedIcon);
export default __webpack_public_path__ + "static/media/completed_icon.03db03dc3232f74685973deabff838fc.svg";
export { ForwardRef as ReactComponent };